<template>
</template>

<script>
    import GlobalMixin from '@/app/shared/mixins/global';
    import ButtonControlMixin from '../mixins/ButtonControlMixin';

    let sv = null;
    export default {
        mixins: [
            GlobalMixin,
            ButtonControlMixin
        ],
        data() {
            return {
                idPanel: 'backoffice',
                className: 'ol-backoffice',
            }
        },
        methods: {
            addButtonMap: function(_map){
                if(!this.url.view || !this.checkPermission(this.acl, 'view'))
                    return false;

                let btn = _map.createBtnImg(
                    this.assetsPathTheme('/map/backoffice.svg'),
                    _map.getControlClassName(this.orderClassName),
                    this.title,
                    [
                        {
                            type: 'click',
                            event: (evt) =>
                            {
                                this.$router.push({
                                    name: this.formatUrl(this.url.view, {moduleCode: this.moduleCode}, '{', '}'),
                                    params: { appCode: this.applicationCode }
                                });
                                evt.stopPropagation();
                            }
                        }
                    ],
                    this.lblBtn
                );
                _map.addControl(this.posBtnMap, btn);
                this.$eventBus.listen(this.moduleCode, 'map.new-feature-initialize', (evt)=>{
                    let el = $(btn.element); if(el) el.hide()
                });
                this.$eventBus.listen(this.moduleCode, 'map.new-feature-finished', (evt)=>{
                    let el = $(btn.element); if(el) el.show()
                });
                return btn;
            },
        }

    }
</script>
